import { fromDateObject, toDate, UnixTimestamp } from "@cervval.js/common/src/tools/timestamps.tools";

/** */
export function ceilDateByMinute(date: UnixTimestamp, minute: number): UnixTimestamp {
    const tsDate = toDate(date);
    const secondCorrection = tsDate.second > 0 ? 1 : 0; // Ceil the second indirectly
    const _minute = Math.ceil((tsDate.minute + secondCorrection) / minute) * minute;
    return fromDateObject({
        year: tsDate.year,
        month: tsDate.month,
        day: tsDate.day,
        minute: _minute,
        hour: tsDate.hour + (minute === 0 && tsDate.minute !== 0 ? 1 : 0)
    }).uts;
}